function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

export const AUTH_ROOT = "/auth";

export const APP_URLS = {
  ALL: "*",
  ROOT: "/",
  TRUE_PLAN: "https://launch2landing.mydigitaloffice.com/index.html",
  DIGI_AUDIT: "https://launch2landing.mydigitaloffice.com/index.html",
  PLATFORM_HOME: "https://launch2landing.mydigitaloffice.com/index.html",
  LOGIN: "/login",
  LOGOUT: "/logout",
  PAGES: {
    CONTACT_US: "/contact-us",
    CONTACT_DETAILS: "/contact-details",
    ERROR_403: "/403",
    ERROR_404: "/404",
    ERROR_500: "/500",
    ERROR_401: "/401",
  },
  HOME: "/auth/home",
  FACT_MANAGER:{
    ROOT: path(AUTH_ROOT, "/fact-manager"),
    LIST: path(AUTH_ROOT, "/fact-manager/list"),
    ITEM: path(AUTH_ROOT, "/fact-manager/:id"),
    ADD: path(AUTH_ROOT, "/fact-manager/add"),
  }, 
  ORGANIZATIONS:{
    ROOT: path(AUTH_ROOT, "/organizations"),
    LIST: path(AUTH_ROOT, "/organizations/list"),
    ITEM: path(AUTH_ROOT, "/organizations/:id")
  },
};
